import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  isCeremonyPreview,
  markIndependenciaCeremonySeen,
  shouldPlayIndependenciaCeremony
} from '../../utils/mesPatrio';
import MexicoWavingFlag from './MexicoWavingFlag';
import useFireworks from './useFireworks';
import './VivaMexicoCeremony.css';

const AUTO_MS = 12000;

export default function VivaMexicoCeremony({ onOpenChange }) {
  const canvasRef = useRef(null);
  const [open, setOpen] = useState(() => shouldPlayIndependenciaCeremony());

  useFireworks(canvasRef, open);

  useEffect(() => {
    if (shouldPlayIndependenciaCeremony()) setOpen(true);
  }, []);

  useEffect(() => {
    onOpenChange?.(open);
  }, [open, onOpenChange]);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    const frame = window.requestAnimationFrame(() => {
      if (!cancelled) markIndependenciaCeremonySeen();
    });
    const timer = isCeremonyPreview()
      ? null
      : window.setTimeout(() => setOpen(false), AUTO_MS);
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frame);
      if (timer) window.clearTimeout(timer);
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div className="viva-ceremony" role="dialog" aria-modal="true" aria-labelledby="viva-mexico-title">
      <canvas ref={canvasRef} className="viva-ceremony__sky" aria-hidden="true" />
      <button type="button" className="viva-ceremony__veil" aria-label="Cerrar saludo" onClick={() => setOpen(false)} />
      <div className="viva-ceremony__stage">
        <p className="viva-ceremony__kicker">15 de septiembre</p>
        <h1 id="viva-mexico-title" className="viva-ceremony__title">
          ¡Viva México!!
        </h1>
        <MexicoWavingFlag />
        <p className="viva-ceremony__sub">Independencia de México</p>
        <button type="button" className="viva-ceremony__continue" onClick={() => setOpen(false)}>
          Continuar a Nexus
        </button>
      </div>
    </div>,
    document.body
  );
}
